/*
 * Open Javascript functions
 * Generally attached to window
 * @author: Elton Jain
*/

define('functions',[], function () {
    "use strict";
    
    // Escape HTML with Break tag
    window.escapeWithBreak = function (str) {
        return nl2br(tmpl.encode(str));
    };

    // 
});
